import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import TrainingActionGroupsList from './TrainingActionGroupsList';

const TrainingActionGroupsSettingsPage: React.FC = () => {
    const pageHeader = {
        title: 'Grupos de Acciones Formativas',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Administración' },
            { name: 'Configuración General' },
            { name: 'Grupos de acciones formativas', href: menuRoutes.generalConfiguration.path + menuRoutes.generalConfiguration.trainingActionGroups },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />
            <div className="p-6">
                <TrainingActionGroupsList />
            </div>
        </div>
    );
};

export default TrainingActionGroupsSettingsPage;
